(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroVideo(section) {
      var video = section.querySelector('video');
      if (!video) return;
      function onPlaying() {
        video.classList.add('hero-video--playing');
      }
      if (!video.paused) {
        video.classList.add('hero-video--playing');
        return;
      }
      video.addEventListener('playing', onPlaying, { once: true });
      var promise = video.play();
      if (promise !== undefined) {
        promise.catch(function () {
          video.classList.add('hero-video--playing');
        });
      }
    }
    document.addEventListener('DOMContentLoaded', function () {
      var section = document.querySelector('.collection_hero');
      if (section) initHeroVideo(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noot-award-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.getElementById('nah-{{ section.id }}');
    if (!section) return;
    var video = section.querySelector('video');
    if (!video) return;
    if (!video.paused) return;
    var p = video.play();
    if (p) p.catch(function () {});
  })();

  } catch(e) { console.error(e); }
})();
})();
